import { useQuery } from '@tanstack/react-query';
import { getPaymentPeriods } from '../services';

export default function useGetPaymentPeriods({ service = undefined }) {
  return useQuery({
    queryKey: ['paymentPeriods', service],
    queryFn: () => getPaymentPeriods({ service }),
    enabled: !!service,
    select: ({ data }) =>
      data.periods.map((period) => ({
        label: `${period.start_date} - ${period.end_date}`,
        value: period.end_date,
      })),
    staleTime: 60 * 60 * 1000,
  });
}
